import {
    options_premium_StorageContent,
    options_mailboxCleanup_Used,
    options_mailboxCleanup_ofUnlimited,
    options_mailboxCleanup_Max,
    options_mailboxCleanup_AmountToUseMailbox,
    options_mailboxCleanup_GB,
    options_mailboxCleanup_MB,
    options_mailboxCleanup_KB,
} from './StorageOptionFull.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react';
import * as React from 'react';
import store from '../store/store';

import { getIconClassName } from '@uifabric/styling/lib/index';
import { ControlIcons } from 'owa-control-icons';
import getAccountInformation from '../actions/getAccountInformation';

const styles = require('./StorageOptionFull.scss');
const classNames = require('classnames/bind').bind(styles);

const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

export interface StorageOptionFullProps {
    isPremium: boolean;
}

@observer
export default class StorageOptionFull extends React.Component<StorageOptionFullProps, {}> {
    constructor(props: StorageOptionFullProps) {
        super(props);
        getAccountInformation();
    }

    render() {
        const isExceededQuota =
            !store.sendQuota.IsUnlimited && store.usageInBytes >= store.sendQuota.Value;
        const progressBarStyle = { width: store.usagePercentage + '%' };
        let storageUsedString: string;

        // Premium option has different description text
        if (this.props.isPremium) {
            storageUsedString = format(
                loc(options_premium_StorageContent),
                (store.sendReceiveQuota.Value / GB).toFixed(2),
                (store.usageInBytes / GB).toFixed(2)
            );
        } else {
            const amountUsed = this.getFormattedTextBasedOnSize(
                store.usageInBytes,
                loc(options_mailboxCleanup_Used)
            );
            const ofMaxAmount = store.sendReceiveQuota.IsUnlimited
                ? loc(options_mailboxCleanup_ofUnlimited)
                : this.getFormattedTextBasedOnSize(
                      store.sendReceiveQuota.Value,
                      loc(options_mailboxCleanup_Max)
                  );
            storageUsedString = amountUsed + ofMaxAmount;
        }

        return (
            <div>
                <span className={styles.progressText}>{storageUsedString}</span>
                <div className={styles.usageContainer}>
                    <div
                        className={classNames(
                            styles.mailboxStorageUsed,
                            isExceededQuota && styles.exceededQuota
                        )}
                        style={progressBarStyle}
                    />
                </div>
                {isExceededQuota && (
                    <div className={styles.warningText}>
                        <div
                            className={classNames(
                                getIconClassName(ControlIcons.Warning),
                                styles.icon
                            )}
                        />
                        <span>
                            {this.getFormattedTextBasedOnSize(
                                store.usageInBytes - store.sendQuota.Value,
                                loc(options_mailboxCleanup_AmountToUseMailbox)
                            )}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    private getFormattedTextBasedOnSize(sizeInBytes: number, stringToFormat: string): string {
        const numberFormat = sizeInBytes >= GB ? GB : sizeInBytes >= MB ? MB : KB;

        const numberUnitString =
            sizeInBytes >= GB
                ? loc(options_mailboxCleanup_GB)
                : sizeInBytes >= MB
                ? loc(options_mailboxCleanup_MB)
                : loc(options_mailboxCleanup_KB);

        return format(stringToFormat, (sizeInBytes / numberFormat).toFixed(2), numberUnitString);
    }
}
